import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FileText,
  BookOpen,
  UserCheck
} from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DashboardOverview = () => {
  const [stats, setStats] = useState({ coaches: 0, applications: 0, gyms: 0, clients: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/stats`);
        setStats(response.data);
      } catch (err) {
        console.error("Failed to fetch dashboard stats:", err);
      }
    };
    fetchStats();
  }, []);

  return (
    <div data-testid="dashboard-overview">
      <h1 className="font-['Outfit'] text-2xl font-bold uppercase mb-8">
        Tableau de bord
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-[#0F0F16] border border-white/10 p-6" data-testid="stat-card-coaches">
          <div className="text-3xl font-bold text-[#0066FF] mb-2">{stats.coaches}</div>
          <div className="text-[#94A3B8] text-sm uppercase tracking-wider">Coachs actifs</div>
        </div>
        <div className="bg-[#0F0F16] border border-white/10 p-6" data-testid="stat-card-applications">
          <div className="text-3xl font-bold text-[#0066FF] mb-2">{stats.applications}</div>
          <div className="text-[#94A3B8] text-sm uppercase tracking-wider">Candidatures</div>
        </div>
        <div className="bg-[#0F0F16] border border-white/10 p-6" data-testid="stat-card-gyms">
          <div className="text-3xl font-bold text-[#0066FF] mb-2">{stats.gyms}</div>
          <div className="text-[#94A3B8] text-sm uppercase tracking-wider">Salles partenaires</div>
        </div>
        <div className="bg-[#0F0F16] border border-white/10 p-6" data-testid="stat-card-clients">
          <div className="text-3xl font-bold text-[#0066FF] mb-2">{stats.clients}</div>
          <div className="text-[#94A3B8] text-sm uppercase tracking-wider">Clients</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Link
          to="/admin/coach-accounts"
          className="bg-[#0F0F16] border border-white/10 p-6 hover:border-[#0066FF]/50 transition-colors"
          data-testid="quick-link-coach-accounts"
        >
          <UserCheck className="w-8 h-8 text-[#0066FF] mb-4" />
          <h3 className="font-semibold mb-2">Comptes Coachs</h3>
          <p className="text-[#94A3B8] text-sm">Créer et gérer les comptes des coachs affiliés</p>
        </Link>
        <Link
          to="/admin/training"
          className="bg-[#0F0F16] border border-white/10 p-6 hover:border-[#0066FF]/50 transition-colors"
          data-testid="quick-link-training"
        >
          <BookOpen className="w-8 h-8 text-[#0066FF] mb-4" />
          <h3 className="font-semibold mb-2">Formation</h3>
          <p className="text-[#94A3B8] text-sm">Gérer les modules et leçons de formation</p>
        </Link>
        <Link
          to="/admin/applications"
          className="bg-[#0F0F16] border border-white/10 p-6 hover:border-[#0066FF]/50 transition-colors"
          data-testid="quick-link-applications"
        >
          <FileText className="w-8 h-8 text-[#0066FF] mb-4" />
          <h3 className="font-semibold mb-2">Candidatures</h3>
          <p className="text-[#94A3B8] text-sm">Consulter et traiter les nouvelles candidatures</p>
        </Link>
      </div>
    </div>
  );
};

export default DashboardOverview;
